const UserActivitiesPage = () => {
    return (
        <div className="flex min-h-[80%] items-center justify-center">
            <div className="bg-white p-8 rounded-lg shadow-[4px_0_10px_rgba(0,0,0,0.25)] text-center">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="64"
                    height="64"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="mx-auto mb-6 text-orange-500"
                >
                    <rect x="2" y="3" width="20" height="18" rx="2" ry="2"></rect>
                    <line x1="12" y1="7" x2="12" y2="11"></line>
                    <line x1="12" y1="15" x2="12.01" y2="15"></line>
                </svg>

                <h1 className="text-4xl font-bold text-gray-800 mb-4">
                    Under Development
                </h1>
                <p className="text-gray-600 text-lg mb-6">
                    This feature is currently under development.
                    Please check back soon.
                </p>
                <div className="text-sm text-gray-500">
                    Thank you.
                </div>
            </div>
        </div>
    );
};

export default UserActivitiesPage;
